import "../../pages/site/site.scss";
import { Button, Drawer, List } from "devextreme-react";
import SelectBox from "devextreme-react/select-box";
import TextBox from "devextreme-react/text-box";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../utils/media-query";
import { OpenedStateMode } from "devextreme/ui/drawer";
import { useLanguage } from "../../contexts/language";
import AsyncStorage from "@react-native-async-storage/async-storage";
const WizeWingsLogo = require("../../assets/images/Logo02Blue6.png");

type HeaderNavigationItem = {
  id: string;
  text: string;
  target: string;
};

const languageOptions = [
  {
    code: "en-US",
    label: "us",
    name: "English",
  },
  {
    code: "pt-BR",
    label: "br",
    name: "Português",
  },
];

const getNavigationItems = (isPortuguese: boolean): HeaderNavigationItem[] => [
  {
    id: "home",
    text: isPortuguese ? "Início" : "Home",
    target: "home",
  },
  {
    id: "products",
    text: isPortuguese ? "Produtos" : "Products",
    target: "app",
  },
  {
    id: "plans",
    text: isPortuguese ? "Planos" : "Plans",
    target: t("PLANS"),
  },
  {
    id: "faq",
    text: "FAQ",
    target: "faq",
  },
];

const renderLanguageOption = (item: (typeof languageOptions)[number]) => (
  <div className="language-select-item">
    {/* <img src={item.flag} alt={item.name} width={24} /> */}
    <span>{item.label}</span>
  </div>
);

// export const navigation = [
//   {
//     id: 1,
//     text: t("APP"),
//     local: t("APP"),
//   },
//   {
//     id: 2,
//     text: t("WEB"),
//     local: t("WEB"),
//   },
//   {
//     id: 3,
//     text: t("PLANS"),
//     local: t("PLANS"),
//   },
//   {
//     id: 4,
//     text: t("ABOUTUS"),
//     local: "/about",
//   },
// ];

const NavigationList = (props: { toggleMenu: Function }) => {
  const navigate = useNavigate();
  const { toggleMenu } = props;
  const { currentLanguage } = useLanguage();
  const navigation = getNavigationItems(currentLanguage?.startsWith("pt"));

  const scrollToDiv = (aId: string) => {
    alert(aId);
    toggleMenu();

    if (aId === "home") {
      navigate("/");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    navigate("/");

    setTimeout(() => {
      const section = document.getElementById(aId);

      if (section) {
        window.scrollTo({
          top: section.offsetTop - 100,
          behavior: "smooth",
        });
      }
    }, 300);
  };

  return (
    <div className="list" style={{ width: "200px" }}>
      <List
        dataSource={navigation}
        hoverStateEnabled={false}
        activeStateEnabled={false}
        focusStateEnabled={false}
        className="item-drawer-menu"
        displayExpr="text"
        onItemClick={(e) => scrollToDiv(`${e.itemData?.target}`)}
      />
    </div>
  );
};

export const HeaderComponent = () => {
  const { isSmall, isXSmall } = useScreenSize();
  const navigate = useNavigate();
  const { toggleLanguage, currentLanguage } = useLanguage();
  const navigation = getNavigationItems(currentLanguage?.startsWith("pt"));
  const [activeNavigation, setActiveNavigation] = useState("plans");
  //drawer
  const [opened, setOpened] = useState(false);
  const openedStateMode: OpenedStateMode = "shrink";

  function onOutsideClick() {
    setOpened(false);
    return true;
  }

  const onPressCountry = async (aCOuntry: string) => {
    await AsyncStorage.setItem("@wizewings:lang", aCOuntry);
    toggleLanguage(aCOuntry);
  };

  const scrollToDiv = (item: HeaderNavigationItem) => {
    setActiveNavigation(item.id);

    if (item.target === "home") {
      navigate("/");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    if (item.id == "faq") {
      navigate("/faq");
      return;
    }

    if (item.id == "plans") {
      navigate("/plans");
      return;
    }

    navigate("/");

    setTimeout(() => {
      const section = document.getElementById(item.target);

      if (section) {
        window.scrollTo({
          top: section.offsetTop - 100,
          behavior: "smooth",
        });
      }
    }, 300);
  };

  const getActiveNavigationIdBySection = (sectionId: string) => {
    if (sectionId === "app" || sectionId === "web") {
      return "products";
    }

    return sectionId;
  };

  useEffect(() => {
    const sections = navigation
      .flatMap((item) => {
        if (item.id === "products") {
          return [
            {
              id: "app",
              target: "app",
              element: document.getElementById("app"),
            },
            {
              id: "web",
              target: "web",
              element: document.getElementById("web"),
            },
          ];
        }

        return [
          {
            id: item.id,
            target: item.target,
            element: document.getElementById(item.target),
          },
        ];
      })
      .filter((section) => section.element !== null);

    if (!sections.length) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (!visibleEntries.length) {
          return;
        }

        const activeSection = sections.find(
          (section) => section.element === visibleEntries[0].target
        );

        if (activeSection) {
          setActiveNavigation(getActiveNavigationIdBySection(activeSection.id));
        }
      },
      {
        root: null,
        rootMargin: "-35% 0px -45% 0px",
        threshold: [0.15, 0.25, 0.4, 0.6],
      }
    );

    sections.forEach((section) => {
      if (section.element) {
        observer.observe(section.element);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [navigation]);

  return (
    <header className={"header-site"}>
      <div className="header-items">
        {(isSmall || isXSmall) && (
          <Button
            // text={t("enter")}
            onClick={() => setOpened(!opened)}
            className="button-menu"
            icon="menu"

            // className="dxButton"
            // width={150}
          />
        )}
        <div
          className="item-header item-logo"
          onClick={() => {
            setActiveNavigation("home");
            navigate("/");
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        >
          <img
            className="header-logo-image"
            src={WizeWingsLogo}
            alt="WizeWings"
          />
        </div>

        {!isSmall && !isXSmall && (
          <nav className="header-navigation" aria-label="Site">
            {navigation.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`header-navigation-item ${
                  activeNavigation === item.id
                    ? "header-navigation-item-active"
                    : ""
                }`}
                onClick={() => scrollToDiv(item)}
              >
                {item.text}
              </button>
            ))}
          </nav>
        )}

        <div className="header-actions">
          <div className="lang-container">
            <SelectBox
              dataSource={languageOptions}
              valueExpr="code"
              displayExpr="label"
              value={currentLanguage?.startsWith("pt") ? "pt-BR" : "en-US"}
              width={54}
              stylingMode="outlined"
              className="language-select"
              itemRender={renderLanguageOption}
              fieldRender={(item) => (
                <div className="language-select-field">
                  {item && renderLanguageOption(item)}
                  <TextBox
                    value={item?.label || ""}
                    readOnly
                    className="language-select-textbox"
                  />
                </div>
              )}
              onValueChanged={(e) => {
                if (e.value) {
                  onPressCountry(e.value);
                }
              }}
            />
          </div>

          <a
            className="header-login-link"
            href={`${
              window.location.protocol + "//" + window.location.host
            }/app`}
            target="_blank"
            rel="noreferrer"
          >
            <Button
              text={t("enter")}
              onClick={() => null}
              className="custom-button-rounded header-login-button"
              width={isSmall || isXSmall ? 90 : 110}
              height={isSmall || isXSmall ? 42 : 48}
            />
          </a>
        </div>
      </div>
      {(isSmall || isXSmall) && (
        <Drawer
          opened={opened}
          openedStateMode={openedStateMode}
          position={"left"}
          revealMode={"slide"}
          component={() => (
            <NavigationList toggleMenu={() => setOpened(!opened)} />
          )}
          closeOnOutsideClick={onOutsideClick}
          className="drawer-menu"
          height={opened ? "auto" : 0}
        ></Drawer>
      )}
    </header>
  );
};
